<template>
  <div>
    <!-- filter section -->
    <DiscountPanelFilterSection 
      class="pl-4"
      :clear-all-filters-trigger="clearAllFiltersTrigger" 
      @clickTag="clickTag"
      @clearAllFilters="clearAllFilters"
    />
    <!-- bundle section -->
    <div class="grid grid-cols-2 px-2.5 gap-x-2 gap-y-4 mt-4">
      <div
        v-for="bundle in pagedDiscountPanelList"
        :key="bundle.bundleId"
      >
        <DiscountPanelCard
          :bundle="bundle"
          :class="isEmptyFilteredDiscountPanel ? '' : 'filtered-test'"
          :select-prop="selectProp"
          :order-test-support-obj="orderTestSupportObj"
        />
      </div>

    </div>
    <PaginationBar
      class="mt-4"
      :items="filteredDiscountPanelList"
      :total="filteredDiscountPanelList.length"
      :total-pages="Math.ceil(filteredDiscountPanelList.length / 14)"
      :page-size="14"
      @changePage="changeDiscountPanelPage"
    />
  </div>
</template>

<script>
import DiscountPanelFilterSection from "./components/DiscountPanelFilterSection.vue";
import DiscountPanelCard from "./components/DiscountPanelCard.vue";
import PaginationBar from "../../../../components/AllTestsPanel/PaginationBar.vue";
import { mapState } from 'vuex';
import _ from "lodash";

export default {
  components: {
    DiscountPanelFilterSection,
    DiscountPanelCard,
    PaginationBar
  },

  props: {
    searchedDiscountPanel: {
      type: Object,
      default: () => {}
    },
    clearAllFiltersTrigger: {
      type: Number,
      default: 0
    },
    selectProp: {
      type: String,
      default: "isSelect"
    },
    orderTestSupportObj: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      discountPanelFilterTagList: [],
      discountPanelPage: 1,
      filteredDiscountPanelList: []
    }
  },

  computed: {
    ...mapState("orderTest", ["isDbsVersion", "dbsMap"]),

    bundleList() {
      return this.orderTestSupportObj?.bundleList || [];
    },

    discountPanelList() {
      if (!this.bundleList) return [];
      return this.bundleList.filter(panel => panel.category !== "customPanel");
    },
    serumDiscountPanelList() {
      if (!this.discountPanelList) return [];
      return this.discountPanelList.filter(panel => 
        ["not_at_home", "both"].includes(panel.section) && !panel.toBeOffline
      );
    },
    dbsDiscountPanelList() {
      if (!this.discountPanelList) return [];
      return this.discountPanelList.filter(panel => 
        ["at_home", "both"].includes(panel.section) && !panel.toBeOffline
      );
    },

    pagedDiscountPanelList() {
      if (!this.filteredDiscountPanelList) {
        return [];
      }
      return this.filteredDiscountPanelList.slice(
        14 * (this.discountPanelPage - 1),
        14 * this.discountPanelPage
      );
    },

    isEmptyFilteredDiscountPanel() {
      return _.isEmpty(this.searchedDiscountPanel);
    },
  },

  watch: {
    isEmptyFilteredDiscountPanel(newVal) {
      if (!newVal) {
        this.filteredDiscountPanelList = [this.searchedDiscountPanel];
      }
    },
    
    serumDiscountPanelList() {
      this.initializeFilteredDiscountPanelList();
    },
    
    isDbsVersion() {
      this.initializeFilteredDiscountPanelList();
    }
  },

  mounted() {
    this.initializeFilteredDiscountPanelList();
  },
  methods: {
    clickTag(selectedTags) {
      if (selectedTags.length === 0) {
        this.filteredDiscountPanelList = this.isDbsVersion
          ? this.dbsDiscountPanelList
          : this.serumDiscountPanelList;
      }
      else {
        let matchedPanelList = [];
        let discountPanelList = this.isDbsVersion
          ? this.dbsDiscountPanelList
          : this.serumDiscountPanelList;
        selectedTags.forEach((tag) => {
          let currentTagMatchedPanels = discountPanelList
            .filter((panel) => tag.bundleIdList.includes(panel.bundleId));
          if (this.isDbsVersion) {
            let dbsIds = this.dbsMap
              .filter(map => tag.bundleIdList.includes(map.originalItemId))
              .map(m => m.dbsItemId);
            let dbsPanels = discountPanelList
              .filter((panel) => dbsIds.includes(panel.bundleId));
            currentTagMatchedPanels = currentTagMatchedPanels.concat(dbsPanels);
          }
          matchedPanelList = matchedPanelList.concat(currentTagMatchedPanels);
        });
        this.filteredDiscountPanelList = matchedPanelList;
      }
      this.changeDiscountPanelPage(1);
    },
    changeDiscountPanelPage(val) {
      this.discountPanelPage = val;
    },
    clearAllFilters() {
      this.filteredDiscountPanelList = this.isDbsVersion
        ? this.dbsDiscountPanelList
        : this.serumDiscountPanelList;
    },

    initializeFilteredDiscountPanelList() {
      this.changeDiscountPanelPage(1);
      this.filteredDiscountPanelList = this.isDbsVersion
        ? this.dbsDiscountPanelList
        : this.serumDiscountPanelList;
    }
  }
}
</script>